import React, { useState } from 'react';
import { CommonModal } from 'wsm-common-modal';
import { useLabels } from 'wsm-common-data';
import BadgeContent from './BadgeContent';
import { badgePropTypes, badgeDefaultProps } from '../types/badgeProps';

const BadgeWrapper = (props) => {
	const { badgeClasses = [], disclaimer = '' } = props;

	const labels = useLabels();
	const [isOpenModal, setOpenModal] = useState(false);

	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	return (
		<>
			<li
				className={`${badgeClasses.join(' ')} vehicle-card-badge badge`}
			>
				<BadgeContent {...props} toggleOpenModal={toggleOpenModal} />
			</li>
			<CommonModal
				title={labels.get('DISCLAIMER_OPTION')}
				isOpen={isOpenModal}
				onClose={toggleOpenModal}
				key="common-modal"
			>
				{/* eslint-disable-next-line react/no-danger */}
				<div dangerouslySetInnerHTML={{ __html: disclaimer }} />
			</CommonModal>
		</>
	);
};

BadgeWrapper.propTypes = badgePropTypes;

BadgeWrapper.defaultProps = badgeDefaultProps;

export default BadgeWrapper;
